 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"abed9d7b3e8288312f9b51e2bdaacdb2e06cf8fb","2":"c8a5cbd4584e0d5a82b8ed19e10e1bd971a69995","3":"39ae161bf8620b8b8c7df6ae79a18de8cd328e92","4":"b072a3a64b00ac1f971f35e50d250f23791a84c1","5":"6b62d0112ddc4fc5190edc97d766e812aacd03a9","6":"13fdbb7c398de9a32571f42ef51142e4c319b4bf","7":"33a1b814717d56d27de93dcff3d1549f0c8bf3e6","8":"94726e6d","10":"260fb190","11":"2b7b2d2a","13":"component---src-pages-404-js","14":"component---src-pages-ai-64-js","15":"component---src-pages-companies-js","16":"component---src-pages-contact-us-js","17":"component---src-pages-content-hub-audio-js","18":"component---src-pages-content-hub-best-of-socials-js","19":"component---src-pages-content-hub-index-js","20":"component---src-pages-content-hub-video-js","21":"component---src-pages-content-hub-written-js","22":"component---src-pages-index-js","23":"component---src-pages-infrared-100-js","24":"component---src-pages-infrared-constituents-js","25":"component---src-pages-infrared-index-js","26":"component---src-pages-infrared-report-js","27":"component---src-pages-our-people-js","28":"component---src-pages-privacy-policy-js","29":"component---src-pages-radar-js","30":"component---src-pages-terms-of-use-js","31":"component---src-templates-ch-search-result-page-js","32":"component---src-templates-ch-series-page-js","33":"component---src-templates-ch-tag-page-js","34":"component---src-templates-ch-video-page-js","35":"component---src-templates-ch-written-page-js","36":"component---src-templates-company-js","37":"component---src-templates-person-js","38":"component---src-templates-report-js","39":"ea88be26"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"5fb4b95de63e7694e411","2":"eb438dd44fee7751227f","3":"22cd58e563babeb123ab","4":"f25d004ca65d8900c64d","5":"3eb04c29767d65a2b8e2","6":"7956a07427b591b57986","7":"5dfc74821d276be09f6c","8":"89f4b7b698f7938f5b66","10":"2a4a3d8c0e47f96bbf76","11":"22c5b2b465f1e8113614","13":"468b6fad4ac77704502d","14":"f4e82b513f494d128fc3","15":"673ac199bd62cd9efd50","16":"65d34a6f2cdb708efbee","17":"4bdeea9fbb09e865a241","18":"8f37cfd7c3c12da44051","19":"a274344410266655c9bd","20":"5564e96264f00ac2e1d4","21":"b5a9059904da05172dc5","22":"7aa7d04c8287751ad25b","23":"e493f7d2699b4a84c35f","24":"e3095aaff903c1a13150","25":"878284ddd3cd19e82632","26":"4c75d6ca47453b8cd54f","27":"c77188737ebffa1c0049","28":"8f8be43ef9195f260846","29":"99e6c3b15325a2de9b35","30":"49041197d25240deceb4","31":"71923d349b3779eeb5ef","32":"3f86a61a0d36ff55ebad","33":"1d98360808604c7dc1d2","34":"64a330c9782e65bffe2a","35":"d3c6318bbda94082e994","36":"f62879d22d3b6aef5e92","37":"f6469251d210b7959dc3","38":"31668190a9ef3e5aa3f1","39":"a7f3b7ddfd74967d1601","42":"ec531d48fb73b37370e3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"abed9d7b3e8288312f9b51e2bdaacdb2e06cf8fb","2":"c8a5cbd4584e0d5a82b8ed19e10e1bd971a69995","3":"39ae161bf8620b8b8c7df6ae79a18de8cd328e92","4":"b072a3a64b00ac1f971f35e50d250f23791a84c1","5":"6b62d0112ddc4fc5190edc97d766e812aacd03a9","6":"13fdbb7c398de9a32571f42ef51142e4c319b4bf","7":"33a1b814717d56d27de93dcff3d1549f0c8bf3e6","8":"94726e6d","10":"260fb190","11":"2b7b2d2a","13":"component---src-pages-404-js","14":"component---src-pages-ai-64-js","15":"component---src-pages-companies-js","16":"component---src-pages-contact-us-js","17":"component---src-pages-content-hub-audio-js","18":"component---src-pages-content-hub-best-of-socials-js","19":"component---src-pages-content-hub-index-js","20":"component---src-pages-content-hub-video-js","21":"component---src-pages-content-hub-written-js","22":"component---src-pages-index-js","23":"component---src-pages-infrared-100-js","24":"component---src-pages-infrared-constituents-js","25":"component---src-pages-infrared-index-js","26":"component---src-pages-infrared-report-js","27":"component---src-pages-our-people-js","28":"component---src-pages-privacy-policy-js","29":"component---src-pages-radar-js","30":"component---src-pages-terms-of-use-js","31":"component---src-templates-ch-search-result-page-js","32":"component---src-templates-ch-series-page-js","33":"component---src-templates-ch-tag-page-js","34":"component---src-templates-ch-video-page-js","35":"component---src-templates-ch-written-page-js","36":"component---src-templates-company-js","37":"component---src-templates-person-js","38":"component---src-templates-report-js","39":"ea88be26"}[chunkId]||chunkId) + "." + {"0":"544e8ef7be559b628091","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
